import {
  Edit as EditIcon,
  CheckCircle as CheckIcon,
  Payment as PaymentIcon,
  LocalShipping as ShippingIcon,
  Cancel as CancelIcon,
  Receipt as ReceiptIcon,
  DoneAll as DoneAllIcon,
} from '@mui/icons-material';

// Configuración de estados para órdenes de venta (chips / legacy values)
export const SALES_ORDER_STATUS_CONFIG = {
  DRAFT: { color: 'default' as const, label: 'Borrador', icon: EditIcon },
  CONFIRMED: { color: 'info' as const, label: 'Confirmada', icon: CheckIcon },
  PARTIAL_PAID: { color: 'warning' as const, label: 'Pago Parcial', icon: PaymentIcon },
  PAID: { color: 'success' as const, label: 'Pagada', icon: CheckIcon },
  DELIVERED: { color: 'success' as const, label: 'Entregada', icon: ShippingIcon },
  CANCELLED: { color: 'error' as const, label: 'Cancelada', icon: CancelIcon },
  REFUNDED: { color: 'error' as const, label: 'Reembolsada', icon: ReceiptIcon },
} as const;

// Configuración de estados de logística para ventas mixtas (independiente del pago).
// Etiquetas alineadas con utils/sales/saleFulfillmentPresentation (fuente única).
// NOT_REQUIRED se omite intencionalmente: no debe renderizarse ningún chip secundario.
export const SALE_FULFILLMENT_STATUS_CONFIG = {
  PENDING: { color: 'warning' as const, label: 'Envío pendiente', icon: ShippingIcon },
  COMPLETED: { color: 'success' as const, label: 'Envío completado', icon: DoneAllIcon },
  FAILED: { color: 'error' as const, label: 'Rechazada', icon: CancelIcon },
  CANCELLED: { color: 'error' as const, label: 'Envío cancelado', icon: CancelIcon },
} as const;

/**
 * Opciones operativas del filtro "Estado de pago" en gestión de ventas.
 * Omite DRAFT / CONFIRMED / DELIVERED / CANCELLED (legacy / no usados en UI).
 */
export const SALES_ORDER_STATUS_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'PARTIAL_PAID', label: 'Pago parcial' },
  { value: 'PAID', label: 'Pagada' },
  { value: 'REFUNDED', label: 'Reembolsada' },
] as const;

/** Opciones del filtro "Estado de entrega" (`deliveryStatus`). */
export const SALES_ORDER_DELIVERY_STATUS_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'NONE', label: 'Pendiente de entrega' },
  { value: 'PARTIAL', label: 'Entrega parcial' },
  { value: 'FULL', label: 'Entrega completa' },
] as const;

/** Opciones del filtro "Estado de envío" (`fulfillmentStatus`). */
export const SALES_ORDER_FULFILLMENT_STATUS_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'PENDING', label: 'Envío pendiente' },
  { value: 'COMPLETED', label: 'Envío completado' },
] as const;
